import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import ListItem from '@fuww/library/src/Markets/ListItem';
import { List } from '@fuww/library/src/List';
import LinkAndAnchor from '../LinkAndAnchor';
import ImageWithUrls from '../ImageWithUrls';
import connectionType from './connectionType';

const Markets = ({ data: { marketsConnection } }) => (
  <List>
    {
      marketsConnection.edges.map(({ node: { id, name, imageUrls } }) => (
        <Fragment key={id}>
          <li>
            <LinkAndAnchor
              route="market"
              params={{ marketId: id }}
            >
              <ListItem
                title={name}
                image={imageUrls[0] && (
                  <ImageWithUrls
                    alt={name}
                    width="100px"
                    height="auto"
                    sizes="100px"
                    imageUrls={imageUrls}
                    srcSet={`${imageUrls[1]
                    } 100w, ${imageUrls[2]
                    } 200w`}
                    placeholderLoadStrategy="instant"
                  />
                )}
              />
            </LinkAndAnchor>
          </li>
        </Fragment>
      ))
    }
  </List>
);

Markets.propTypes = {
  data: PropTypes.shape({
    marketsConnection: connectionType,
  }),
};

Markets.defaultProps = {
  data: null,
};

export default Markets;
